import { GATES_API_URL } from 'constants/ApiConstants';

import * as types from '../actionTypes';

/**
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").GateDetailsIsReadyAction}
 */
export const gateDetailsIsReady = (meta = {}) => ({
  type: types.GATE_READY,
  meta,
});

/**
 * @param {string} gateId
 * @param {Object} [meta={}]
 * @returns {import("../types/actions").DownloadPublicQRCodeAction}
 */
export const downloadPublicQRCode = (gateId, meta = {}) => ({
  type: types.DOWNLOAD_PUBLIC_QR_CODE_REQUEST,
  payload: {
    request: {
      method: 'GET',
      url: `${GATES_API_URL}/${gateId}/qrcode`,
      headers: {
        Accept: 'image/png',
      },
    },
    gateId,
  },
  meta,
});

/**
 * @param {Blob} data
 * @param {Object={}} meta
 * @returns {import("../types/actions").DownloadPublicQRCodeSuccessAction}
 */
export const downloadPublicQRCodeSuccess = (data, meta = {}) => ({
  type: types.DOWNLOAD_PUBLIC_QR_CODE_SUCCESS,
  payload: data,
  meta,
});

/**
 * @param {string} error
 * @param {Object={}} meta
 * @returns {import("../types/actions").DownloadPublicQRCodeFailureAction}
 */
export const downloadPublicQRCodeFailure = (error, meta = {}) => ({
  type: types.DOWNLOAD_PUBLIC_QR_CODE_FAILURE,
  payload: error,
  meta,
});

/**
 * @param {string} gateId
 * @param {Object} params
 * @param {Object} [meta={}]
 */
export const fetchGateOpenings = (gateId, params, meta = {}) => ({
  type: types.FETCH_GATE_OPENINGS,
  payload: {
    request: {
      method: 'GET',
      url: `${GATES_API_URL}/${gateId}/openings`,
      params
    },
    gateId,
  },
  meta,
});

/**
 * @param {undefined} payload
 * @param {string} gateId
 * @param {Object} [meta={}]
 * @param {boolean} [isAppend=false]
 */
export const fetchGateOpeningsSuccess = (payload, gateId, meta = {}, isAppend = false) => ({
  type: types.FETCH_GATE_OPENINGS_SUCCESS,
  payload: {
    ...payload,
    gateId,
    isAppend,
  },
  meta,
});
